import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'fh_cookie_consent_v1';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Delay to let hero render first
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-title"
      className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-50 bg-white border border-brand-blueMist rounded-md shadow-2xl shadow-brand-blueDark/20 p-5 animate-in slide-in-from-bottom-4 fade-in duration-500"
      data-testid="cookie-consent"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="w-10 h-10 rounded-md bg-brand-blueMist text-brand-blueDark flex items-center justify-center flex-shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <h3 id="cookie-title" className="font-display text-lg text-brand-blueDark leading-tight mb-1">Cookies & Datenschutz</h3>
          <p className="text-xs text-brand-ink/70 leading-relaxed">
            Wir verwenden ausschliesslich technisch notwendige Cookies (Sprachwahl, Consent). Keine Analyse- oder Marketing-Cookies. Details in unserer{' '}
            <Link to="/datenschutz" className="text-brand-blue hover:text-brand-blueDark underline">Datenschutzerklärung</Link>.
          </p>
        </div>
        <button
          onClick={decline}
          aria-label="Schliessen"
          className="text-brand-ink/40 hover:text-brand-blueDark transition-colors"
          data-testid="cookie-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="flex flex-col sm:flex-row gap-2">
        <button
          onClick={accept}
          className="flex-1 bg-brand-blueDark hover:bg-brand-blue text-white px-4 py-2.5 text-xs font-bold uppercase tracking-wider rounded-sm transition-colors"
          data-testid="cookie-accept"
        >
          Verstanden
        </button>
        <Link
          to="/datenschutz"
          onClick={() => setVisible(false)}
          className="flex-1 text-center bg-white border border-brand-blueMist hover:border-brand-blue text-brand-blueDark px-4 py-2.5 text-xs font-bold uppercase tracking-wider rounded-sm transition-colors"
          data-testid="cookie-details"
        >
          Mehr erfahren
        </Link>
      </div>
    </div>
  );
};

export default CookieConsent;
